/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

import { RouteCodes } from '@core/config/route-codes';
import { RoutesActivationModel } from '@models/.';

/*
  configurazione per attivare/disattivare le rotte.

  La key deve corrispondere al parametro "routeCode" definito
  per ogni rotta nel file di routing.
  Il value può essere un boolean oppure una string che costituirà l'url di redirect
  associtato a quel routeCode.

  Questa è la configurazione di base che rende attive tutte le rotte e NON deve
  essere modificato se non per aggiungere e censire nuove rotte.
  Per impostare una configurazione custom è necessario seguire questo procedimento:
  - creare un nuovo file routes-activation.ts nel container
  - creare un oggetto ROUTES_ACTIVATION che estende quello del core come nell'esempio

    import { ROUTES_ACTIVATION as CORE_ROUTES_ACTIVATION } from '@core/config/routes-activation';

    export const ROUTES_ACTIVATION: {} = {
      ...CORE_ROUTES_ACTIVATION,
      LANDING: false,
      QUOTATION: true
    };

  - modificare le rotte che si vuole disattivare o fare redirect
  - provvedere nell'app module ROUTES_ACTIVATION usando la strategy useValue
    { provide: 'ROUTES_ACTIVATION', useValue: ROUTES_ACTIVATION }
 */

export const ROUTES_ACTIVATION: RoutesActivationModel = {
  [RouteCodes.welcome]: true,
  [RouteCodes.summary]: true,
  [RouteCodes.finish]: true,
  [RouteCodes.release]: true,
  [RouteCodes.stop]: true,
  [RouteCodes.notes]: true,
  [RouteCodes.quotation]: true,
  [RouteCodes.quotationCalculate]: true,
  [RouteCodes.obligations]: true,
  [RouteCodes.documentsRequest]: true,
  [RouteCodes.documentsView]: true,
  [RouteCodes.resolution]: true,
  [RouteCodes.adequacy]: true,
  [RouteCodes.recognition]: true,
  [RouteCodes.consents]: true,
  [RouteCodes.contractSigning]: true,
  [RouteCodes.waiting]: true,
  [RouteCodes.customerInfo]: true,
  [RouteCodes.financialData]: true,
  [RouteCodes.atcChoice]: true,
  [RouteCodes.tfrReleaseQuote]: true,
  [RouteCodes.cardConfirm]: true,
  [RouteCodes.dataCollection]: true,
  [RouteCodes.surveyCollection]: true,
  [RouteCodes.foreigner]: true,
  [RouteCodes.usesReport]: true,
  [RouteCodes.withdraw]: true,
  [RouteCodes.resume]: true,
  [RouteCodes.instructions]: true,
  [RouteCodes.handoverStart]: true,
  [RouteCodes.address]: true,
  [RouteCodes.fundChoice]: true,
  [RouteCodes.pensionData]: true,
  [RouteCodes.salaryData]: true
};
